// extracted by mini-css-extract-plugin
export default {"brass-button-secundary":"Button_brass-button-secundary__1ZfB+","brass-button":"Button_brass-button__VoOqt","brass-button-round":"Button_brass-button-round__Xldze"};